import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import Container from '../../../Core/Container';
import RichText from '../../../Core/RichText';
import Accordion from '../../../Core/Accordion';

import { Heading, ContentWrapper, StyledCtas } from './styles';

const AccordionSection = ({ data }) => {
  if (!data) return null;

  const {
    anchorName,
    backgroundColor,
    contentAlignment,
    elements,
    sectionContainerHeading,
    sectionContainerHeadingColor,
    sectionSubheading,
    ctas,
  } = data;

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Heading
          contentAlignment={contentAlignment}
          headingColor={sectionContainerHeadingColor}
        >
          {children}
        </Heading>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Heading
          contentAlignment={contentAlignment}
          headingColor={sectionContainerHeadingColor}
        >
          {children}
        </Heading>
      ),
    },
  };

  return (
    <Container backgroundColor={backgroundColor} as="section" id={anchorName}>
      {sectionContainerHeading && (
        <RichText document={sectionContainerHeading} options={header} />
      )}
      {sectionSubheading && <RichText document={sectionSubheading} />}
      <ContentWrapper className={contentAlignment}>
        {elements &&
          elements.map(item => <Accordion key={item.id} data={item} />)}
        {ctas && <StyledCtas ctas={ctas} direction="row" alignment="center" />}
      </ContentWrapper>
    </Container>
  );
};

AccordionSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default AccordionSection;
